import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function LinkedInCallback() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const state = params.get('state');
    const error = params.get('error');

    if (window.opener) {
      window.opener.postMessage(
        { type: 'LINKEDIN_AUTH', code, state, error },
        window.location.origin
      );
      window.close();
    }
  }, [location.search]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif' }}>
      <p>LinkedIn-Anmeldung wird verarbeitet…</p>
    </div>
  );
}
